module.exports = __webpack_public_path__ + "img/Jump3.b4ce6900.svg";